/**
 * Generate from url: https://localhost:44305/swagger/v1/swagger.json
 * It is recommended not to modify the document
 * Total count: 5
 **/
import type {
  ProductRegistrationCreateOrUpdateDto,
  ProductRegistrationDto,
  PagedResultDto,
} from './types';
import { api } from 'boot/axios';

/**
 * POST /api/app/product-registration
 **/
export function create(payload: ProductRegistrationCreateOrUpdateDto) {
  return api.post<ProductRegistrationDto>('/api/app/product-registration', {
    ...payload,
  });
}

/**
 * GET /api/app/product-registration/{id}
 **/
export function get(id: string) {
  return api.get<ProductRegistrationDto>(`/api/app/product-registration/${id}`, {});
}

/**
 * GET /api/app/product-registration
 **/
export function getList(params: {
  about?: string | undefined;
  filter?: string | undefined;
  sorting?: string | undefined;
  skipCount?: number | undefined;
  maxResultCount?: number | undefined;
}) {
  return api.get<PagedResultDto<ProductRegistrationDto>>('/api/app/product-registration', {
    params: params,
  });
}

/**
 * DELETE /api/app/product-registration/{id}
 **/
export function remove(id: string) {
  return api.delete<void>(`/api/app/product-registration/${id}`, {});
}


/**
 * PUT /api/app/product-registration/{id}
 **/
export function update(id: string, payload: ProductRegistrationCreateOrUpdateDto) {
  return api.put<ProductRegistrationDto>('/api/app/product-registration/${id}', {
    ...payload,
  });
}

export default {
  create,
  get,
  getList,
  remove,
  update,
};
  